<ng-container *ngIf="state.model && state.model.job">
  <div class="job-bar-status popover-text">
    <div class="flex">
      <y42-job-cancellation-button [jobRequestId]="state.model.job.request_id"></y42-job-cancellation-button>
      <div>
        <p class="job-bar-row-name">Status</p>
        <p
          class="job-status"
          [ngClass]="{
            'status-success-text': state.model.valid,
            'status-failure-text': state.model.invalid,
            'status-neutral-text-blue': state.model.queued,
            partial: state.model.partial
          }"
        >
          {{ state.model.job.status }}
        </p>
      </div>
    </div>
    <div *ngIf="state.model.mode">
      <p class="job-bar-row-name">Mode</p>
      <div class="flex items-center">
        <y42-icon [icon]="importIcon" class="job-import" [ngClass]="state.model.mode"></y42-icon>
        <p class="job-mode">{{ state.model.mode }}</p>
      </div>
    </div>
  </div>

  <div *ngIf="state.model.job.created_at" class="job-bar-row popover-text">
    <p class="job-bar-row-name">Started at</p>
    <p class="job-bar-row-value">{{ state.model.job.created_at | formatDate : DateTimeFormat.ShortDateTime }}</p>
  </div>

  <div *ngIf="state.model.job.finished_at" class="job-bar-row popover-text">
    <p class="job-bar-row-name">Finished at</p>
    <p class="job-bar-row-value">{{ state.model.job.finished_at | formatDate : DateTimeFormat.ShortDateTime }}</p>
  </div>

  <div *ngIf="state.model.csvDownloadUrl" class="job-bar-row popover-text">
    <p class="job-bar-row-name">
      <a [href]="state.model.csvDownloadUrl" target="_blank" download>Download CSV</a>
    </p>
  </div>

  <div class="job-bar-row popover-text">
    <p class="job-bar-row-name">Data tests</p>
    <p class="job-bar-row-value">{{ state.model.job.tests?.length ?? 0 }}</p>
  </div>

  <div class="job-bar-row popover-text" *ngIf="state.model.datasource && state.model.datasource.url">
    <p class="job-bar-row-name">Datasource</p>
    <a
      class="job-bar-row-value"
      (click)="navigateToDatasource($event, state.model.datasource.url)"
      [attr.href]="state.model.datasource.url"
      >{{ state.model.datasource.name }}</a
    >
  </div>

  <div class="job-bar-row popover-text">
    <p class="job-bar-row-name">Job Id</p>
    <p class="job-bar-row-valu">{{ state.model.job.request_id }}</p>
  </div>

  <div class="job-bar-row popover-text">
    <p class="job-bar-row-name">Chain Id</p>
    <p class="job-bar-row-value">{{ state.model.job.parent_job_id }}</p>
  </div>

  <div *ngIf="state.model.job.triggeredBy" class="job-bar-row popover-text">
    <p class="job-bar-row-name">Triggered by</p>
    <div class="job-triggered-by">
      <y42-job-triggered-by-user-avatar
        class="mr-[5px]"
        [triggeredBy]="state.model.job.triggeredBy"
        [clickable]="true"
        [showNonUserLabel]="true"
        [sizePx]="15"
      ></y42-job-triggered-by-user-avatar>
    </div>
  </div>

  <div class="job-bar-row popover-text">
    <p class="job-bar-row-name">Total size</p>
    <p class="job-bar-row-value">{{ state.model.job.details.size_in_bytes || '-' }}</p>
  </div>
  <div class="job-bar-row popover-text">
    <p class="job-bar-row-name">Number of new rows</p>
    <p class="job-bar-row-value">{{ state.model.job.details.current_import_row_count || '-' }}</p>
  </div>
  <div class="job-bar-row popover-text" *ngIf="state.model.syncTime">
    <p class="job-bar-row-name">Sync time</p>
    <p class="job-bar-row-value">{{ state.model.syncTime }}</p>
  </div>

  <div class="job-bar-actions popover-text">
    <button
      mat-raised-button
      data-test="job-info-button-view-request"
      class="mr-3 job-bar-actions-button"
      *ngIf="state.model.job.settingsValidationResult"
      (click)="showRequest.emit(state.model.job.request_id)"
    >
      View request
    </button>

    <button
      *ngIf="showLogsButton"
      (click)="showLogs.emit(state.model.eventId)"
      [disabled]="!state.model.hasLogs"
      mat-raised-button
      class="job-bar-actions-button"
      data-test="job-info-button-logs"
    >
      <fa-icon class="button-icon mr-2" [icon]="['fal', 'bars']"></fa-icon>
      {{ state.model.hasLogs ? 'View logs' : 'No logs' }}
    </button>
  </div>
</ng-container>
